export default [
  {
    label: 'Home',
    hasLink: true,
    hasMenu: true,
    path: '/',
    iconMenu: 'icon-pie-chart',
    children: [
      {
        label: 'Loja',
        hasLink: true,
        hasMenu: true,
        path: 'store',
        iconMenu: 'icon-cart',
        children: []
      },
      {
        label: 'Pedidos',
        hasLink: true,
        hasMenu: true,
        path: 'orders',
        iconMenu: 'icon-clipboard3',
        children: [
          {
            label: 'Detalhes do pedido #:code',
            hasLink: true,
            hasMenu: false,
            path: ':identifier/:code',
            children: []
          }
        ]
      },
      {
        label: 'Histórico',
        hasLink: true,
        hasMenu: true,
        path: 'logs',
        iconMenu: 'icon-history',
        children: []
      },
      {
        label: 'Predefinições',
        hasLink: true,
        hasMenu: true,
        path: 'presets',
        iconMenu: 'icon-equalizer',
        children: [
          {
            label: 'Moovin > Cnova > Categorização',
            hasLink: true,
            hasMenu: false,
            path: 'ecommerce/moovin/marketplace/cnova/categorization',
            children: []
          },
          {
            label: 'Moovin > Colombo > Categorização',
            hasLink: true,
            hasMenu: false,
            path: 'ecommerce/moovin/marketplace/colombo/categorization',
            children: []
          },
          {
            label: 'Moovin > Mercado Livre > Categorização',
            hasLink: true,
            hasMenu: false,
            path: 'ecommerce/moovin/marketplace/mercadoLivre/categorization',
            children: []
          },
          {
            label: 'Moovin > Mercado Livre > Cor',
            hasLink: true,
            hasMenu: false,
            path: 'ecommerce/moovin/marketplace/mercadoLivre/color',
            children: []
          },
          {
            label: 'Moovin > Netshoes > Categorização',
            hasLink: true,
            hasMenu: false,
            path: 'ecommerce/moovin/marketplace/netshoes/categorization',
            children: []
          },
          {
            label: 'Moovin > Netshoes > Cor',
            hasLink: true,
            hasMenu: false,
            path: 'ecommerce/moovin/marketplace/netshoes/color',
            children: []
          },
          {
            label: 'Moovin > Netshoes > Marca',
            hasLink: true,
            hasMenu: false,
            path: 'ecommerce/moovin/marketplace/netshoes/brand',
            children: []
          },
          {
            label: 'Moovin > Netshoes > Tamanho',
            hasLink: true,
            hasMenu: false,
            path: 'ecommerce/moovin/marketplace/netshoes/size',
            children: []
          },
          {
            label: 'Moovin > Shein > Categorização',
            hasLink: true,
            hasMenu: false,
            path: 'ecommerce/moovin/marketplace/shein/categorization',
            children: []
          }
        ]
      },
      {
        label: 'Usuários',
        hasLink: true,
        hasMenu: true,
        path: 'users',
        iconMenu: 'icon-user',
        children: []
      },
      {
        label: 'Segurança',
        hasLink: true,
        hasMenu: true,
        path: 'security',
        iconMenu: 'icon-key',
        children: []
      },
      {
        label: 'Marketplace',
        hasLink: false,
        hasMenu: false,
        path: 'marketplace',
        children: [
          {
            label: 'Amazon',
            hasLink: false,
            hasMenu: true,
            path: 'amazon',
            children: [
              {
                label: 'Produtos',
                hasLink: true,
                hasMenu: true,
                path: 'products',
                iconMenu: 'icon-barcode',
                children: [
                  {
                    label: 'Editar #:sku',
                    hasLink: true,
                    hasMenu: false,
                    path: ':sku',
                    children: []
                  }
                ]
              },
              {
                label: 'Configuração',
                hasLink: true,
                hasMenu: true,
                path: 'configuration',
                iconMenu: 'icon-cog',
                children: []
              },
              {
                label: 'Cargas',
                hasLink: true,
                hasMenu: true,
                path: 'feeds',
                iconMenu: 'icon-stack2',
                children: [
                  {
                    label: 'Detalhe #:code',
                    hasLink: true,
                    path: 'detail/:code',
                    children: []
                  }
                ]
              },
              {
                label: 'Contas',
                hasLink: true,
                hasMenu: true,
                path: 'accounts',
                iconMenu: 'icon-users',
                children: [
                  {
                    hasLink: true,
                    hasMenu: false,
                    children: []
                  }
                ]
              }
            ]
          },
          {
            label: 'Carrefour',
            hasLink: false,
            hasMenu: true,
            path: 'carrefour',
            children: [
              {
                label: 'Produtos',
                hasLink: true,
                hasMenu: true,
                path: 'products',
                iconMenu: 'icon-barcode',
                children: [
                  {
                    label: 'Editar #:sku',
                    hasLink: true,
                    hasMenu: false,
                    path: ':sku',
                    children: []
                  }
                ]
              },
              {
                label: 'Configuração',
                hasLink: true,
                hasMenu: true,
                path: 'configuration',
                iconMenu: 'icon-cog',
                children: []
              },
              {
                label: 'Cargas',
                hasLink: true,
                hasMenu: true,
                path: 'feeds',
                iconMenu: 'icon-stack2',
                children: [
                  {
                    label: 'Detalhe #:code',
                    hasLink: true,
                    path: 'detail/:code',
                    children: []
                  }
                ]
              }
            ]
          },
          {
            label: 'Centauro',
            hasLink: false,
            hasMenu: true,
            path: 'centauro',
            children: [
              {
                label: 'Produtos',
                hasLink: true,
                hasMenu: true,
                path: 'products',
                iconMenu: 'icon-barcode',
                children: [
                  {
                    label: 'Editar #:sku',
                    hasLink: true,
                    hasMenu: false,
                    path: ':sku',
                    children: []
                  }
                ]
              },
              {
                label: 'Configuração',
                hasLink: true,
                hasMenu: true,
                path: 'configuration',
                iconMenu: 'icon-cog',
                children: []
              }
            ]
          },
          {
            label: 'Cnova',
            hasLink: false,
            hasMenu: true,
            path: 'cnova',
            children: [
              {
                label: 'Produtos',
                hasLink: true,
                hasMenu: true,
                path: 'products',
                iconMenu: 'icon-barcode',
                children: [
                  {
                    label: 'Editar #:sku',
                    hasLink: true,
                    hasMenu: false,
                    path: ':sku',
                    children: []
                  },
                  {
                    label: 'Match',
                    hasLink: true,
                    hasMenu: true,
                    path: 'match',
                    iconMenu: 'icon-shrink2',
                    children: []
                  },
                  {
                    label: 'Migração',
                    hasLink: true,
                    hasMenu: true,
                    path: 'migration',
                    iconMenu: 'icon-download',
                    children: []
                  }
                ]
              },
              {
                label: 'Configuração',
                hasLink: true,
                hasMenu: true,
                path: 'configuration',
                iconMenu: 'icon-cog',
                children: []
              }
            ]
          },
          {
            label: 'Colombo',
            hasLink: false,
            hasMenu: true,
            path: 'colombo',
            children: [
              {
                label: 'Produtos',
                hasLink: true,
                hasMenu: true,
                path: 'products',
                iconMenu: 'icon-barcode',
                children: [
                  {
                    label: 'Editar #:sku',
                    hasLink: true,
                    hasMenu: false,
                    path: ':sku',
                    children: []
                  }
                ]
              },
              {
                label: 'Configuração',
                hasLink: true,
                hasMenu: true,
                path: 'configuration',
                iconMenu: 'icon-cog',
                children: []
              }
            ]
          },
          {
            label: 'ConectaLa',
            hasLink: false,
            hasMenu: true,
            path: 'conectaLa',
            children: [
              {
                label: 'Produtos',
                hasLink: true,
                hasMenu: true,
                path: 'products',
                iconMenu: 'icon-barcode',
                children: [
                  {
                    label: 'Editar #:sku',
                    hasLink: true,
                    hasMenu: false,
                    path: ':sku',
                    children: []
                  }
                ]
              },
              {
                label: 'Configuração',
                hasLink: true,
                hasMenu: true,
                path: 'configuration',
                iconMenu: 'icon-cog',
                children: []
              }
            ]
          },
          {
            label: 'GFG',
            hasLink: false,
            hasMenu: true,
            path: 'gfg',
            children: [
              {
                label: 'Produtos',
                hasLink: true,
                hasMenu: true,
                path: 'products',
                iconMenu: 'icon-barcode',
                children: [
                  {
                    label: 'Editar #:sku',
                    hasLink: true,
                    hasMenu: false,
                    path: ':sku',
                    children: []
                  }
                ]
              },
              {
                label: 'Configuração',
                hasLink: true,
                hasMenu: true,
                path: 'configuration',
                iconMenu: 'icon-cog',
                children: []
              },
              {
                label: 'Cargas',
                hasLink: true,
                hasMenu: true,
                path: 'feeds',
                iconMenu: 'icon-stack2',
                children: [
                  {
                    label: 'Detalhe #:code',
                    hasLink: true,
                    path: 'detail/:code',
                    children: []
                  }
                ]
              }
            ]
          },
          {
            label: 'Integracommerce',
            hasLink: false,
            hasMenu: true,
            path: 'integracommerce',
            children: [
              {
                label: 'Produtos',
                hasLink: true,
                hasMenu: true,
                path: 'products',
                iconMenu: 'icon-barcode',
                children: [
                  {
                    label: 'Editar #:sku',
                    hasLink: true,
                    hasMenu: false,
                    path: ':sku',
                    children: []
                  }
                ]
              },
              {
                label: 'Configuração',
                hasLink: true,
                hasMenu: true,
                path: 'configuration',
                iconMenu: 'icon-cog',
                children: []
              }
            ]
          },
          {
            label: 'Leroy Merlin',
            hasLink: false,
            hasMenu: true,
            path: 'leroy',
            children: [
              {
                label: 'Produtos',
                hasLink: true,
                hasMenu: true,
                path: 'products',
                iconMenu: 'icon-barcode',
                children: [
                  {
                    label: 'Editar #:sku',
                    hasLink: true,
                    hasMenu: false,
                    path: ':sku',
                    children: []
                  }
                ]
              },
              {
                label: 'Configuração',
                hasLink: true,
                hasMenu: true,
                path: 'configuration',
                iconMenu: 'icon-cog',
                children: []
              },
              {
                label: 'Cargas',
                hasLink: true,
                hasMenu: true,
                path: 'feeds',
                iconMenu: 'icon-stack2',
                children: [
                  {
                    label: 'Detalhe #:code',
                    hasLink: true,
                    path: 'detail/:code',
                    children: []
                  }
                ]
              }
            ]
          },
          {
            label: 'Madeira Madeira',
            hasLink: false,
            hasMenu: true,
            path: 'madeira',
            children: [
              {
                label: 'Atributos',
                hasLink: true,
                hasMenu: true,
                path: 'attributes',
                iconMenu: 'icon-list',
                children: [
                  {
                    label: 'Criar',
                    hasLink: true,
                    hasMenu: false,
                    path: 'create',
                    children: []
                  },
                  {
                    label: 'Editar #:attributeId',
                    hasLink: true,
                    hasMenu: false,
                    path: 'edit',
                    children: []
                  }
                ]
              },
              {
                label: 'Produtos',
                hasLink: true,
                hasMenu: true,
                path: 'products',
                iconMenu: 'icon-barcode',
                children: [
                  {
                    label: 'Editar #:sku',
                    hasLink: true,
                    hasMenu: false,
                    path: ':sku',
                    children: []
                  }
                ]
              },
              {
                label: 'Configuração',
                hasLink: true,
                hasMenu: true,
                path: 'configuration',
                iconMenu: 'icon-cog',
                children: []
              }
            ]
          },
          {
            label: 'Magalu',
            hasLink: false,
            hasMenu: true,
            path: 'magalu',
            children: [
              {
                label: 'Produtos',
                hasLink: true,
                hasMenu: true,
                path: 'products',
                iconMenu: 'icon-barcode',
                children: [
                  {
                    label: 'Editar #:sku',
                    hasLink: true,
                    hasMenu: false,
                    path: ':sku',
                    children: []
                  }
                ]
              },
              {
                label: 'Configuração',
                hasLink: true,
                hasMenu: true,
                path: 'configuration',
                iconMenu: 'icon-cog',
                children: []
              },
              {
                label: 'Contas',
                hasLink: true,
                hasMenu: true,
                path: 'accounts',
                iconMenu: 'icon-users',
                children: [
                  {
                    hasLink: true,
                    hasMenu: false,
                    children: []
                  }
                ]
              }
            ]
          },
          {
            label: 'Mercado Livre',
            hasLink: false,
            hasMenu: true,
            path: 'mercadoLivre',
            children: [
              {
                label: 'Anúncios',
                hasLink: true,
                hasMenu: true,
                path: 'announcements',
                iconMenu: 'icon-bullhorn',
                children: [
                  {
                    label: 'Editar #:identifier',
                    hasLink: true,
                    path: ':identifier',
                    children: []
                  },
                  {
                    label: 'Migração',
                    hasLink: true,
                    hasMenu: true,
                    path: 'migration',
                    iconMenu: 'icon-download',
                    children: []
                  },
                  {
                    label: 'Match',
                    hasLink: true,
                    hasMenu: true,
                    path: 'match',
                    iconMenu: 'icon-shrink2',
                    children: []
                  }
                ]
              },
              {
                label: 'Anunciar',
                hasLink: false,
                hasMenu: false,
                path: 'announcement',
                children: [
                  {
                    label: 'Resumo de anúncios disponibilizados',
                    hasLink: false,
                    hasMenu: false,
                    path: 'report',
                    children: []
                  }
                ]
              },
              {
                label: 'Configuração',
                hasLink: true,
                hasMenu: true,
                path: 'configuration',
                iconMenu: 'icon-cog',
                children: []
              },
              {
                label: 'Contas',
                hasLink: true,
                hasMenu: true,
                path: 'accounts',
                iconMenu: 'icon-users',
                children: [
                  {
                    hasLink: true,
                    hasMenu: false,
                    children: []
                  }
                ]
              }
            ]
          },
          {
            label: 'Netshoes',
            hasLink: false,
            hasMenu: true,
            path: 'netshoes',
            children: [
              {
                label: 'Produtos',
                hasLink: true,
                hasMenu: true,
                path: 'products',
                iconMenu: 'icon-barcode',
                children: [
                  {
                    label: 'Editar #:sku',
                    hasLink: true,
                    hasMenu: false,
                    path: ':sku',
                    children: []
                  }
                ]
              },
              {
                label: 'Configuração',
                hasLink: true,
                hasMenu: true,
                path: 'configuration',
                iconMenu: 'icon-cog',
                children: []
              }
            ]
          },
          {
            label: 'Polishop',
            hasLink: false,
            hasMenu: true,
            path: 'polishop',
            children: [
              {
                label: 'Produtos',
                hasLink: true,
                hasMenu: true,
                path: 'products',
                iconMenu: 'icon-barcode',
                children: [
                  {
                    label: 'Editar #:sku',
                    hasLink: true,
                    hasMenu: false,
                    path: ':sku',
                    children: []
                  }
                ]
              },
              {
                label: 'Configuração',
                hasLink: true,
                hasMenu: true,
                path: 'configuration',
                iconMenu: 'icon-cog',
                children: []
              }
            ]
          },
          {
            label: 'Sicoob',
            hasLink: false,
            hasMenu: true,
            path: 'sicoob',
            children: [
              {
                label: 'Produtos',
                hasLink: true,
                hasMenu: true,
                path: 'products',
                iconMenu: 'icon-barcode',
                children: [
                  {
                    label: 'Editar #:sku',
                    hasLink: true,
                    hasMenu: false,
                    path: ':sku',
                    children: []
                  }
                ]
              },
              {
                label: 'Configuração',
                hasLink: true,
                hasMenu: true,
                path: 'configuration',
                iconMenu: 'icon-cog',
                children: []
              }
            ]
          },
          {
            label: 'Privalia',
            hasLink: false,
            hasMenu: true,
            path: 'privalia',
            children: [
              {
                label: 'Produtos',
                hasLink: true,
                hasMenu: true,
                path: 'products',
                iconMenu: 'icon-barcode',
                children: [
                  {
                    label: 'Editar #:sku',
                    hasLink: true,
                    hasMenu: false,
                    path: ':sku',
                    children: []
                  }
                ]
              },
              {
                label: 'Configuração',
                hasLink: true,
                hasMenu: true,
                path: 'configuration',
                iconMenu: 'icon-cog',
                children: []
              }
            ]
          },
          {
            label: 'Decathlon',
            hasLink: false,
            hasMenu: true,
            path: 'decathlon',
            children: [
              {
                label: 'Produtos',
                hasLink: true,
                hasMenu: true,
                path: 'products',
                iconMenu: 'icon-barcode',
                children: [
                  {
                    label: 'Editar #:sku',
                    hasLink: true,
                    hasMenu: false,
                    path: ':sku',
                    children: []
                  }
                ]
              },
              {
                label: 'Configuração',
                hasLink: true,
                hasMenu: true,
                path: 'configuration',
                iconMenu: 'icon-cog',
                children: []
              }
            ]
          },
          {
            label: 'KeepRunning',
            hasLink: false,
            hasMenu: true,
            path: 'keepRunning',
            children: [
              {
                label: 'Produtos',
                hasLink: true,
                hasMenu: true,
                path: 'products',
                iconMenu: 'icon-barcode',
                children: [
                  {
                    label: 'Editar #:sku',
                    hasLink: true,
                    hasMenu: false,
                    path: ':sku',
                    children: []
                  }
                ]
              },
              {
                label: 'Configuração',
                hasLink: true,
                hasMenu: true,
                path: 'configuration',
                iconMenu: 'icon-cog',
                children: []
              }
            ]
          },
          {
            label: 'Ramarim',
            hasLink: false,
            hasMenu: true,
            path: 'ramarim',
            children: [
              {
                label: 'Produtos',
                hasLink: true,
                hasMenu: true,
                path: 'products',
                iconMenu: 'icon-barcode',
                children: [
                  {
                    label: 'Editar #:sku',
                    hasLink: true,
                    hasMenu: false,
                    path: ':sku',
                    children: []
                  }
                ]
              },
              {
                label: 'Configuração',
                hasLink: true,
                hasMenu: true,
                path: 'configuration',
                iconMenu: 'icon-cog',
                children: []
              }
            ]
          },
          {
            label: 'Comforflex',
            hasLink: false,
            hasMenu: true,
            path: 'comfortflex',
            children: [
              {
                label: 'Produtos',
                hasLink: true,
                hasMenu: true,
                path: 'products',
                iconMenu: 'icon-barcode',
                children: [
                  {
                    label: 'Editar #:sku',
                    hasLink: true,
                    hasMenu: false,
                    path: ':sku',
                    children: []
                  }
                ]
              },
              {
                label: 'Configuração',
                hasLink: true,
                hasMenu: true,
                path: 'configuration',
                iconMenu: 'icon-cog',
                children: []
              }
            ]
          },
          {
            label: 'Sicredi',
            hasLink: false,
            hasMenu: true,
            path: 'sicredi',
            children: [
              {
                label: 'Produtos',
                hasLink: true,
                hasMenu: true,
                path: 'products',
                iconMenu: 'icon-barcode',
                children: [
                  {
                    label: 'Editar #:sku',
                    hasLink: true,
                    hasMenu: false,
                    path: ':sku',
                    children: []
                  }
                ]
              },
              {
                label: 'Configuração',
                hasLink: true,
                hasMenu: true,
                path: 'configuration',
                iconMenu: 'icon-cog',
                children: []
              }
            ]
          },
          {
            label: 'MaisCorreios',
            hasLink: false,
            hasMenu: true,
            path: 'maisCorreios',
            children: [
              {
                label: 'Produtos',
                hasLink: true,
                hasMenu: true,
                path: 'products',
                iconMenu: 'icon-barcode',
                children: [
                  {
                    label: 'Editar #:sku',
                    hasLink: true,
                    hasMenu: false,
                    path: ':sku',
                    children: []
                  }
                ]
              },
              {
                label: 'Configuração',
                hasLink: true,
                hasMenu: true,
                path: 'configuration',
                iconMenu: 'icon-cog',
                children: []
              }
            ]
          },
          {
            label: 'Renner',
            hasLink: false,
            hasMenu: true,
            path: 'renner',
            children: [
              {
                label: 'Produtos',
                hasLink: true,
                hasMenu: true,
                path: 'products',
                iconMenu: 'icon-barcode',
                children: [
                  {
                    label: 'Editar #:sku',
                    hasLink: true,
                    hasMenu: false,
                    path: ':sku',
                    children: []
                  }
                ]
              },
              {
                label: 'Configuração',
                hasLink: true,
                hasMenu: true,
                path: 'configuration',
                iconMenu: 'icon-cog',
                children: []
              }
            ]
          },
          {
            label: 'Shopee',
            hasLink: false,
            hasMenu: true,
            path: 'shopee',
            children: [
              {
                label: 'Produtos',
                hasLink: true,
                hasMenu: true,
                path: 'products',
                iconMenu: 'icon-barcode',
                children: [
                  {
                    label: 'Editar #:sku',
                    hasLink: true,
                    hasMenu: false,
                    path: ':sku',
                    children: []
                  }
                ]
              },
              {
                label: 'Configuração',
                hasLink: true,
                hasMenu: true,
                path: 'configuration',
                iconMenu: 'icon-cog',
                children: []
              },
              {
                label: 'Contas',
                hasLink: true,
                hasMenu: true,
                path: 'accounts',
                iconMenu: 'icon-users',
                children: [
                  {
                    hasLink: true,
                    hasMenu: false,
                    children: []
                  }
                ]
              }
            ]
          },
          {
            label: 'TikTokShop',
            hasLink: false,
            hasMenu: true,
            path: 'tikTokShop',
            children: [
              {
                label: 'Produtos',
                hasLink: true,
                hasMenu: true,
                path: 'products',
                iconMenu: 'icon-barcode',
                children: [
                  {
                    label: 'Editar #:sku',
                    hasLink: true,
                    hasMenu: false,
                    path: ':sku',
                    children: []
                  }
                ]
              },
              {
                label: 'Configuração',
                hasLink: true,
                hasMenu: true,
                path: 'configuration',
                iconMenu: 'icon-cog',
                children: []
              },
              {
                label: 'Contas',
                hasLink: true,
                hasMenu: true,
                path: 'accounts',
                iconMenu: 'icon-users',
                children: [
                  {
                    hasLink: true,
                    hasMenu: false,
                    children: []
                  }
                ]
              }
            ]
          },
          {
            label: 'Shein',
            hasLink: false,
            hasMenu: true,
            path: 'shein',
            children: [
              {
                label: 'Produtos',
                hasLink: true,
                hasMenu: true,
                path: 'products',
                iconMenu: 'icon-barcode',
                children: [
                  {
                    label: 'Editar #:sku',
                    hasLink: true,
                    hasMenu: false,
                    path: ':sku',
                    children: []
                  }
                ]
              },
              {
                label: 'Configuração',
                hasLink: true,
                hasMenu: true,
                path: 'configuration',
                iconMenu: 'icon-cog',
                children: []
              },
              {
                label: 'Contas',
                hasLink: true,
                hasMenu: true,
                path: 'accounts',
                iconMenu: 'icon-users',
                children: [
                  {
                    hasLink: true,
                    hasMenu: false,
                    children: []
                  }
                ]
              }
            ]
          },
          {
            label: 'Skyhub',
            hasLink: false,
            hasMenu: true,
            path: 'skyhub',
            children: [
              {
                label: 'Produtos',
                hasLink: true,
                hasMenu: true,
                path: 'products',
                iconMenu: 'icon-barcode',
                children: [
                  {
                    label: 'Editar #:sku',
                    hasLink: true,
                    hasMenu: false,
                    path: ':sku',
                    children: []
                  }
                ]
              },
              {
                label: 'Configuração',
                hasLink: true,
                hasMenu: true,
                path: 'configuration',
                iconMenu: 'icon-cog',
                children: []
              }
            ]
          },
          {
            label: 'Ricardo Eletro',
            hasLink: false,
            hasMenu: true,
            path: 'ricardoEletro',
            children: [
              {
                label: 'Produtos',
                hasLink: true,
                hasMenu: true,
                path: 'products',
                iconMenu: 'icon-barcode',
                children: [
                  {
                    label: 'Editar #:sku',
                    hasLink: true,
                    hasMenu: false,
                    path: ':sku',
                    children: []
                  }
                ]
              },
              {
                label: 'Configuração',
                hasLink: true,
                hasMenu: true,
                path: 'configuration',
                iconMenu: 'icon-cog',
                children: []
              },
              {
                label: 'Cargas',
                hasLink: true,
                hasMenu: true,
                path: 'feeds',
                iconMenu: 'icon-stack2',
                children: [
                  {
                    label: 'Detalhe #:code',
                    hasLink: true,
                    path: 'detail/:code',
                    children: []
                  }
                ]
              }
            ]
          },
          {
            label: 'Walmart',
            hasLink: false,
            hasMenu: true,
            path: 'walmart',
            children: [
              {
                label: 'Produtos',
                hasLink: true,
                hasMenu: true,
                path: 'products',
                iconMenu: 'icon-barcode',
                children: [
                  {
                    label: 'Editar #:sku',
                    hasLink: true,
                    hasMenu: false,
                    path: ':sku',
                    children: []
                  }
                ]
              },
              {
                label: 'Configuração',
                hasLink: true,
                hasMenu: true,
                path: 'configuration',
                iconMenu: 'icon-cog',
                children: []
              }
            ]
          },
          {
            label: 'WebContinental',
            hasLink: false,
            hasMenu: true,
            path: 'webcontinental',
            children: [
              {
                label: 'Produtos',
                hasLink: true,
                hasMenu: true,
                path: 'products',
                iconMenu: 'icon-barcode',
                children: [
                  {
                    label: 'Editar #:sku',
                    hasLink: true,
                    hasMenu: false,
                    path: ':sku',
                    children: []
                  }
                ]
              },
              {
                label: 'Configuração',
                hasLink: true,
                hasMenu: true,
                path: 'configuration',
                iconMenu: 'icon-cog',
                children: []
              }
            ]
          },
          {
            label: 'Zoom',
            hasLink: false,
            hasMenu: true,
            path: 'zoom',
            children: [
              {
                label: 'Produtos',
                hasLink: true,
                hasMenu: true,
                path: 'products',
                iconMenu: 'icon-barcode',
                children: [
                  {
                    label: 'Editar #:sku',
                    hasLink: true,
                    hasMenu: false,
                    path: ':sku',
                    children: []
                  }
                ]
              },
              {
                label: 'Configuração',
                hasLink: true,
                hasMenu: true,
                path: 'configuration',
                iconMenu: 'icon-cog',
                children: []
              }
            ]
          }
        ]
      },
      {
        label: 'E-commerce',
        hasLink: false,
        hasMenu: false,
        path: 'ecommerce',
        children: [
          {
            label: 'Moovin',
            hasLink: false,
            hasMenu: true,
            path: 'moovin',
            children: [
              {
                label: 'Produtos',
                hasLink: true,
                hasMenu: true,
                path: 'products',
                iconMenu: 'icon-barcode',
                children: []
              },
              {
                label: 'Configuração',
                hasLink: true,
                hasMenu: true,
                path: 'configuration',
                iconMenu: 'icon-cog',
                children: []
              }
            ]
          },
          {
            label: '1EG',
            hasLink: false,
            hasMenu: true,
            path: 'oneeg',
            children: [
              {
                label: 'Produtos',
                hasLink: true,
                hasMenu: true,
                path: 'products',
                iconMenu: 'icon-barcode',
                children: []
              },
              {
                label: 'Configuração',
                hasLink: true,
                hasMenu: true,
                path: 'configuration',
                iconMenu: 'icon-cog',
                children: []
              }
            ]
          },
          {
            label: 'Ecomece',
            hasLink: false,
            hasMenu: true,
            path: 'ecomece',
            children: [
              {
                label: 'Produtos',
                hasLink: true,
                hasMenu: true,
                path: 'products',
                iconMenu: 'icon-barcode',
                children: []
              },
              {
                label: 'Configuração',
                hasLink: true,
                hasMenu: true,
                path: 'configuration',
                iconMenu: 'icon-cog',
                children: []
              }
            ]
          }
        ]
      },
      {
        label: 'Frete',
        hasLink: false,
        hasMenu: false,
        path: 'shipment',
        children: [
          {
            label: 'Frenet',
            hasLink: false,
            hasMenu: true,
            path: 'frenet',
            children: [
              {
                label: 'Configuração',
                hasLink: true,
                hasMenu: true,
                path: 'configuration',
                iconMenu: 'icon-cog',
                children: []
              }
            ]
          },
          {
            label: 'Intelipost',
            hasLink: false,
            hasMenu: true,
            path: 'intelipost',
            children: [
              {
                label: 'Configuração',
                hasLink: true,
                hasMenu: true,
                path: 'configuration',
                iconMenu: 'icon-cog',
                children: []
              }
            ]
          }
        ]
      },
      {
        label: 'ERP',
        hasLink: false,
        hasMenu: false,
        path: 'erp',
        children: [
          {
            label: 'Flexy',
            hasLink: false,
            hasMenu: true,
            path: 'flexy',
            children: [
              {
                label: 'Produtos',
                hasLink: true,
                hasMenu: true,
                path: 'products',
                iconMenu: 'icon-barcode',
                children: [
                  {
                    label: 'Editar #:productId',
                    hasLink: true,
                    hasMenu: false,
                    path: ':productId',
                    children: []
                  }
                ]
              },
              {
                label: 'Configuração',
                hasLink: true,
                hasMenu: true,
                path: 'configuration',
                iconMenu: 'icon-cog',
                children: []
              }
            ]
          },
          {
            label: 'Tiny',
            hasLink: false,
            hasMenu: true,
            path: 'tiny',
            children: [
              {
                label: 'Produtos',
                hasLink: true,
                hasMenu: true,
                path: 'products',
                iconMenu: 'icon-barcode',
                children: [
                  {
                    label: 'Editar #:productId',
                    hasLink: true,
                    hasMenu: false,
                    path: ':productId',
                    children: []
                  }
                ]
              },
              {
                label: 'Configuração',
                hasLink: true,
                hasMenu: true,
                path: 'configuration',
                iconMenu: 'icon-cog',
                children: []
              }
            ]
          }
        ]
      },
      {
        label: 'Ferramenta',
        hasLink: false,
        hasMenu: false,
        path: 'tool',
        children: [
          {
            label: 'Ações em lote',
            hasLink: false,
            hasMenu: true,
            path: 'batch',
            children: [
              {
                label: 'Tarefas',
                hasLink: true,
                hasMenu: true,
                path: 'tasks',
                iconMenu: 'icon-clipboard3',
                children: [
                  {
                    label: 'Criar',
                    hasLink: true,
                    hasMenu: false,
                    path: 'create',
                    children: []
                  },
                  {
                    label: 'Detalhe :identifier',
                    hasLink: true,
                    hasMenu: false,
                    path: 'detail/:identifier',
                    children: []
                  }
                ]
              }
            ]
          },
          {
            label: 'Integração com API',
            hasLink: false,
            hasMenu: true,
            path: 'api',
            children: [
              {
                label: 'Produtos',
                hasLink: true,
                hasMenu: true,
                path: 'products',
                iconMenu: 'icon-barcode',
                children: [
                  {
                    label: 'Editar #:productId',
                    hasLink: true,
                    hasMenu: false,
                    path: ':productId',
                    children: []
                  }
                ]
              },
              {
                label: 'Configuração',
                hasLink: true,
                hasMenu: true,
                path: 'configuration',
                iconMenu: 'icon-cog',
                children: []
              },
              {
                label: 'Tokens',
                hasLink: true,
                hasMenu: true,
                path: 'tokens',
                iconMenu: 'icon-key',
                children: [
                  {
                    label: 'Criar',
                    hasLink: true,
                    hasMenu: false,
                    path: 'create',
                    children: []
                  },
                  {
                    label: 'Editar :identifier',
                    hasLink: true,
                    hasMenu: false,
                    path: ':identifier',
                    children: []
                  }
                ]
              },
              {
                label: 'Histórico',
                hasLink: true,
                hasMenu: true,
                path: 'logs',
                iconMenu: 'icon-history',
                children: []
              }
            ]
          }
        ]
      }
    ]
  }
]



// WEBPACK FOOTER //
// ./src/storage/breadcrumb.js